import React from "react";

const HexColorLabel = ({ hexCode }) => (
  <span className="color-dot" style={{ "--color": hexCode }} />
);
export default HexColorLabel;
